import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  private snackbarSetup: object = {
    panelClass: "snackbar",
    duration: 6000,
    horizontalPosition: "center",
    verticalPosition: "bottom",
  }

  constructor(
    private snackBar: MatSnackBar
  ) { }

  /**
   * Simple function to use the snackbar in various components.
   * 
   * @param message - The message string that will be showed in the snackbar.
   */
  show(message: string): void {
    this.snackBar.open(message, 'Ok', this.snackbarSetup)
  }

  /**
   * Shows a snackbar with an error message.
   */
  showError(message: string): void {
    this.snackBar.open('Erro: ' + message, 'Ok', this.snackbarSetup)
  }
}
